import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';
import { getFavoritesRequestParams } from '../common/favoritesServiceHelper';

export function getWebViewerServers() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_servers'
      })
    }
  );
};

export function getWebViewerServerById(serverId) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_server_by_id',
        id: serverId,
      })
    }
  );
};

export function addWebViewerServers(
  type,
  connectionCount = null,
  clientId = null,
  term,
  linkConnectionCount = null,
  connectionSharingPolicy,
  linkCount = 0,
) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'add_web_viewer_server',
        type: type,
        connection_count: connectionCount,
        client_id: clientId,
        term: term,
        link_connection_count: linkConnectionCount,
        connection_sharing_policy: connectionSharingPolicy,
        link_count: linkCount,
      }),
    }
  );
};

export function editWebViewerServer(
  serverId,
  connectionCount,
  term,
  linkConnectionCount,
  connectionSharingPolicy,
  linkCount = 0,
) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'edit_web_viewer_server',
        id: serverId,
        term: term,
        connection_count: connectionCount,
        link_connection_count: linkConnectionCount,
        connection_sharing_policy: connectionSharingPolicy,
        link_count: linkCount,
      }),
    }
  );
};

export function getWebViewerServerHistory(serverId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_server_history',
        server_id: serverId
      })
    }
  ).then(history => history)
    .catch(error => {
      throw error
    });
};

export function getWebViewerServerHistoryById(id = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_server_history_by_id',
        id
      })
    }
  )
};

export function assignWebViewerServerToClient(serverId, clientId) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'assign_web_viewer_server_to_client',
        server_id: serverId,
        client_id: clientId
      })
    }
  );
}

export function getWebViewerServerByKey(serverKey = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_server_by_key',
        server_key: serverKey
      })
    }
  );
}

export function removeWebViewerServers(serverIds = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'remove_web_viewer_servers',
        server_ids: serverIds
      })
    }
  );
}

export function restoreWebViewerServers(serverIds = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'restore_web_viewer_servers',
        server_ids: serverIds
      })
    }
  );
}

export function deactivateWebViewerServer(webViewerServerId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'deactivate_web_viewer_server',
        server_id: webViewerServerId
      })
    }
  );
}

export function reactivateWebViewerServer(webViewerServerId, deviceKey = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'reactivate_web_viewer_server',
        server_id: webViewerServerId,
        device_key: deviceKey
      })
    }
  );
}

export function getWebViewerServerLivingStates() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_server_living_states'
      })
    }
  );
}

export function addWebViewerServerToFavorites(serverId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'web_viewer_server', 'add', serverId
    )
  );
}

export function removeWebViewerServerFromFavorites(serverId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'web_viewer_server', 'remove', serverId
    )
  );
}



// WEBPACK FOOTER //
// ./src/services/webViewerServers.js